module.exports = __webpack_public_path__ + "static/img/big.da2f719c.png";